export default __webpack_public_path__ + "static/media/background-1440.f80f7ec2.jpeg";